import React from "react";

const FieldMedic = () => {
  return (
    <div className="wholeDiv">
      <div className="titleText">
        <b>Field Medic</b>
      </div>
      <div className="helpDescription">
        <b>Information about the Field Medic perk</b>
      </div>
      <div className="textBox">
        <div className="perkDescr">
          The <b>Field Medic</b> is focused on healing and support, keeping
          teammates alive during intense combat situations. The Field Medic perk
          emphasizes healing abilities and providing essential support.
        </div>
        <div className="perkInfo">
          <b>Weapons</b>: The Field Medic has access to medical gear. These
          tools help heal teammates while also dealing moderate damage when
          necessary.
        </div>
        <div className="listText">
          <b>Benefits</b> acquired by leveling this perk:
          <div className="bonusList">
            <div className="bonusList">
              <ul>
                <li>Bonuses for Medic weapons:</li>
                <ul>
                  <li>Increase in fire speed;</li>
                  <li>Increase in reload speed;</li>
                  <li>Increase in amount ammunition magazines;</li>
                  <li>Increase in pickup amount of ammunition;</li>
                  <li>Discount on ammunition;</li>
                  <li>Reduced weapon price;</li>
                </ul>
                <li>General bonuses:</li>
                <ul>
                  <li>Increase in healing amount;</li>
                  <li>Increase in recharge of syringe;</li>
                  <li>Increase in movement speed;</li>
                  <li>Increase in armor resistance;</li>
                  <li>Discount on armor;</li>
                  <li>Increase in carry weight;</li>
                  <li>Increase in recoil control;</li>
                </ul>
              </ul>
            </div>
            <b>Team Role</b>: Field Medics are crucial for sustaining the team
            during long waves, especially when dealing with tough enemies or
            when the team is low on health. Their ability to heal teammates
            makes them indispensable in tight situations.
          </div>
        </div>
      </div>
    </div>
  );
};

export default FieldMedic;
